import React, { type FC, ReactElement, useEffect, useState } from 'react';
import { Form } from 'antd';
import { Modal } from '@g2u/ui-kit';
import { observer } from 'mobx-react-lite';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import { ConfirmCustomerFile } from 'components';
import { BookingStore } from 'store';

export namespace CustomerUpdateModal {
  export type Props = {
    isOpen: boolean;
    modalTitle: string | ReactElement<any>;
    okText: string;
    onOk: (data: JsonDataItem | null) => void;
    onCancel: () => void;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { onCancel, isOpen, onOk, modalTitle, okText, dataTestId } = props;
    const { customer, setCustomer } = BookingStore;
    const [form] = Form.useForm();

    const [showCustomerUpdateModal, setShowCustomerUpdateModal] = useState<boolean>(isOpen);
    const [isCusotmerUpdating, setIsCustomerUpdating] = useState<boolean>(false);

    useEffect(() => {
      setShowCustomerUpdateModal(isOpen);
    }, [isOpen]);

    const handleUpdateCustomerFile = (updatedProfile: JsonDataItem | null) => {
      updatedProfile && setCustomer(updatedProfile);
      setShowCustomerUpdateModal(false);
      onOk(updatedProfile);
    };

    const handleProfileUpdating = (status: boolean) => {
      setIsCustomerUpdating(status);
    };

    return (
      <Modal.$
        wide
        open={showCustomerUpdateModal}
        destroyOnClose
        maskClosable={false}
        title={modalTitle}
        okText={okText}
        cancelText="&lt; Back"
        onOk={() => {
          form.submit();
        }}
        okButtonProps={{
          loading: isCusotmerUpdating,
        }}
        onCancel={onCancel}
        cancelButtonProps={{
          disabled: isCusotmerUpdating,
        }}
        dataTestId={dataTestId ?? 'customer-update-modal'}
      >
        <ConfirmCustomerFile.$
          form={form}
          customer={customer}
          onLoading={handleProfileUpdating}
          onUpdated={handleUpdateCustomerFile}
        />
      </Modal.$>
    );
  });
}
